import "./Highlights.css"

export default function Highlights() {
  const highlightsData = [
    {
      id: 1,
      number: "2010",
      description: "Foundation year",
      iconPath: "/icons/atom.webp", // Place your icon file in public/icons/
    },
    {
      id: 2,
      number: "+15",
      description: "Years of experience",
      iconPath: "/icons/plant.webp", // Replace with your actual file names
    },
    {
      id: 3,
      number: "+300",
      description: "Delivered projects",
      iconPath: "/logos/circle.webp",
    },
    {
      id: 4,
      number: "+50",
      description: "Awards & counting",
      iconPath: "/icons/trophy.webp",
    },
    {
      id: 5,
      number: "100",
      description: "Imaginarees on board",
      iconPath: "/logos/people.webp",
    },
    {
      id: 6,
      number: "99%",
      description: "Recommendation rate",
      iconPath: "/logos/thumb.webp",
    },
    {
      id: 7,
      number: "78",
      description: "Customer NPS score",
      iconPath: "/logos/meter.webp",
    },
    {
      id: 8,
      number: "4",
      description: "Offices worldwide",
      iconPath: "/icons/office.webp",
    },
  ]

  return (
    <section className="highlights-section">
      <div className="container">
        <div className="highlights-header">
          <h2 className="company-text">COMPANY</h2>
          <h3 className="highlights-text">HIGHLIGHTS</h3>
        </div>

        <div className="highlights-grid">
          {highlightsData.map((item, index) => (
            <div key={item.id} className="highlight-card" style={{ animationDelay: `${index * 0.1}s` }}>
              <div className="highlights-card-icon">
                <img
                  src={item.iconPath || "/placeholder.svg"}
                  alt={`${item.description} icon`}
                  className="icon-image"
                />
              </div>
              <div className="card-number">{item.number}</div>
              <div className="card-description">{item.description}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
